const Form088EN = {
    stepName: {
        importantNotes: "Important Notes",
        information: "Information",
        confirmation: "Confirmation",
    },
    title: {
        applicantParticulars: "Applicant's Particulars",
        schoolInformation: "School Information",
        note: "Note",
        collectionStatement: "Personal Data Collection Statement",
    },
    label: {
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        nameEn: "Name (English)",
        nameCn: "Name (Chinese)",
        email: "Email (for receiving the verification email of the “Member Zone” )",
        schoolTelNo: "School Telephone No.",
        schoolName: "Name of School",
        schoolChop: "Chop of School",
        principalName: "Name of Principal",
        principalSignature: "Name of Principal / Name of School Supervisor",
        date: "Date",
        noNameCn: "I do not have a Chinese name.",
        supervisorOrPrincipal: {
            supervisor: "Supervisor",
            principal: "Principal",
        },
    },
    note: {
        note1: `Teachers who wish to gain access to the `,
        note2: `Member Zone of “Sharing of Resources
        from the Gifted Education School Network”`,
        note3: ` (“Member Zone”) should complete the following eform and submit it to school administrator for endorsement.`,
        note4: ` The Education Bureau is committed to ensuring all personal data to be handled in accordance with  the  relevant  provisions  of  the `,
        note5: ` Personal  Data  (Privacy)  Ordinance  (PDPO).`,
        note6: ` For  details,  please refer to our`,
        note7: ` {{statement}}.`,
        note8: ` For enquiries, please contact Mr Daniel KWONG ( Tel. No.: 3698 3480).`,
    },
    errorMsg: {
        alphabetsOnly: "Character type (alphabets only)",
        chineseOnly: "Character type (chinese only)",
    },
};
export default Form088EN;
